module.exports = __webpack_public_path__ + "static/media/absa.87e57a4e.png";